import { ICellRendererParams } from 'ag-grid-community';

import { TextLine } from 'core/elements';

export const RequestedByCell = ({ data }: ICellRendererParams) => {
  return (
    <>
      <TextLine text={data.requesterUserName} />
      <TextLine text={data.requesterUserEmployeeId} isSubText />
    </>
  );
};
